






























































import { Vue, Component } from 'vue-property-decorator'
import Topbar from '@/components/layout/Topbar.vue'
import Banner from '@/components/layout/Banner.vue'
import Footer from '@/components/layout/Footer.vue'
import Title from '@/components/common/Title.vue'
import { ConfigStore } from '@/store/config'
import { getKey } from '@/utils/key'
import type { Entry } from '@/models/enrolls/enroll'
import { Enroll } from '@/models/enrolls/enroll'
import { fetchEnrollConfig } from '@/apis/enroll/enrollConfig'

@Component({
  components: { Topbar, Banner, Footer, Title },
})
export default class Index extends Vue {
  getKey = getKey

  entries: Enroll[] = []

  async created() {
    const entriesRaw = await fetchEnrollConfig()
    const entries: Enroll[] = entriesRaw ?? []
    this.entries = entries.filter((a) => !a.hidden)
  }
  /*get  entries () {
    const entriesRaw =await fetchEnrollConfig()
    const entries: Enroll[] = entriesRaw ?? []
    const visiableEntries = entries.filter(a => !a.hidden)

    return [
      visiableEntries.filter(a => !a.disabled),
      visiableEntries.filter(a => a.disabled)
    ].flat()
  }*/

  handleClick(name: string) {
    this.$router.push(`/enroll/${name}`)
  }
}
